import { DetailsTabKey } from '../../../../../../clients/sidebar/components/DetailsTab';

const DASHBOARD_TABS: DetailsTabKey[] = [
  'taskInfo',
  'attachments',
  'comments',
  'activity'
];

export const getAvailableDashboardTabs = ({
  showAttachments,
  showIntegrationsTab
}: {
  showAttachments: boolean;
  showIntegrationsTab: boolean;
}): DetailsTabKey[] => {
  const tabs = showAttachments
    ? DASHBOARD_TABS
    : DASHBOARD_TABS.filter(tab => tab !== 'attachments');
  return showIntegrationsTab ? [...tabs, 'integrations'] : tabs;
};
